import styles from 'sections/shared/calculateEvent/calculateEvent.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import ContactForm from 'components/contactForm/ContactForm';
import { BEIGE, DARK_BLACK } from 'constants/shared';

export const CalculateEvent = ({ isBgBlack }: { isBgBlack?: boolean }) => {
    return (
        <section
            id="section-about-us-calculate-event"
            className={`${generalStyles.heightAuto} ${styles.calculateEventSection}`}
            style={{ background: isBgBlack ? DARK_BLACK : BEIGE }}
        >
            <Element name="calculateEvent">
                <div className={generalStyles.container}>
                    <ContactForm />
                </div>
            </Element>
        </section>
    );
};
